import api from '../api'
import router from '../../../../router'

import {CHANGE_PROGRESS, FULLFILL_USER, CLEAR_STATE, SET_LOGIN_ERRORS} from '../mutations/available'

import _ from 'lodash'

export const getUserInfo = async ({commit}) => {
    try {
        const userData = await api.getUserInfo()
        if (_.isEmpty(userData)) {
            return
        }

        commit(FULLFILL_USER, userData)
    } catch (e) {

    }
}

export const login = async ({state, dispatch, commit, rootState}, {email, password, language}) => {
    if (state.progress) {
        return
    }

    commit(CHANGE_PROGRESS, true)
    dispatch('resetLoginErrors')

    try {
        const userData = await api.login(email, password, language)
        commit(FULLFILL_USER, userData)
        router.push({path: "/"})
    } catch (e) {
        const emailErrors = _.get(e, 'body.email', [])
        const passwordErrors = _.get(e, 'body.password', [])
        const commonErrors = _.get(e, 'body.common', [])

        commit(SET_LOGIN_ERRORS, {
            email: emailErrors,
            password: passwordErrors,
            common: commonErrors
        })
    }

    commit(CHANGE_PROGRESS, false)
}

export const logout = async ({commit, state, dispatch}) => {
    if (state.progress) {
        return
    }

    commit(CHANGE_PROGRESS, true)

    try {
        dispatch('beforeLogout', null, {
            root: true
        })
        await api.logout()
        commit(CLEAR_STATE)

        dispatch('afterLogout', null, {
            root: true
        })

        router.push({path: "/login"})
    } catch (e) {
        console.log(e)
    }

    commit(CHANGE_PROGRESS, false)
}

export const resetLoginErrors = async ({commit}) => {
    commit(SET_LOGIN_ERRORS, {
        email: [],
        password: [],
        common: []
    })
}